import { render, staticRenderFns } from "./PureOption.vue?vue&type=template&id=0b55b2a4&scoped=true&"
import script from "./PureOption.vue?vue&type=script&lang=js&"
export * from "./PureOption.vue?vue&type=script&lang=js&"
import style0 from "./PureOption.vue?vue&type=style&index=0&id=0b55b2a4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b55b2a4",
  null
  
)

export default component.exports